import { Component } from '@angular/core';

@Component({
  selector: 'portal-step-2-svg',
  standalone: true,
  templateUrl: './step-2.component.svg',
  styleUrl: './step-2.component.scss',
})
export class Step2SvgComponent {}
